export default __webpack_public_path__ + "static/media/contract_info.cc82789b.svg";